var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("PurchaseRequests.ChooseRawMaterial"),
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { "label-width": "100px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("PurchaseRequests.Store") } },
            [
              _c("v-select", {
                attrs: {
                  options: _vm.stores,
                  label: "name",
                  reduce: function (store) {
                    return store.uuid
                  },
                  disabled: "",
                },
                model: {
                  value: _vm.listQuery.storeId,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "storeId", $$v)
                  },
                  expression: "listQuery.storeId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("route.Supplier") } },
            [
              _c("v-select", {
                attrs: {
                  options: _vm.suppliers,
                  label: "name",
                  reduce: function (supplier) {
                    return supplier.uuid
                  },
                },
                model: {
                  value: _vm.listQuery.supplierId,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "supplierId", $$v)
                  },
                  expression: "listQuery.supplierId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("PurchaseRequests.Category") } },
            [
              _c("v-select", {
                attrs: {
                  options: _vm.categories,
                  label: "name",
                  reduce: function (category) {
                    return category.uuid
                  },
                },
                model: {
                  value: _vm.listQuery.categoryId,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "categoryId", $$v)
                  },
                  expression: "listQuery.categoryId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("PurchaseRequests.KeyWord") } },
            [
              _c("el-input", {
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.fetchData($event)
                  },
                },
                model: {
                  value: _vm.listQuery.keyword,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "keyword", $$v)
                  },
                  expression: "listQuery.keyword",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.fetchData } },
                [_vm._v(_vm._s(_vm.$t("PurchaseRequests.Search")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.rawMaterials !== null
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("PurchaseRequests.Result") } },
                [
                  _c(
                    "el-table",
                    { attrs: { data: _vm.rawMaterials, height: "300" } },
                    [
                      _c("el-table-column", {
                        attrs: { label: _vm.$t("route.Supplier") },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(scope.row.supplier.name) +
                                      "\n          "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4153162720
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("PurchaseRequests.RawMaterial"),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        scope.row.nameEng
                                          ? scope.row.nameEng
                                          : scope.row.nameChin
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1839815187
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("PurchaseRequests.Action"),
                          width: "100",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  !_vm.handleIsSelected(scope.row)
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "warning",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleSelect(scope.row)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("PurchaseOrders.Select")
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.handleIsSelected(scope.row)
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "danger",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDeselect(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("PurchaseOrders.Deselect")
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1162143264
                        ),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("pagination", {
                    attrs: {
                      total: _vm.total,
                      page: _vm.listQuery.page,
                      limit: _vm.listQuery.limit,
                      "auto-scroll": false,
                      "pager-count": 5,
                    },
                    on: {
                      "update:page": function ($event) {
                        return _vm.$set(_vm.listQuery, "page", $event)
                      },
                      "update:limit": function ($event) {
                        return _vm.$set(_vm.listQuery, "limit", $event)
                      },
                      pagination: _vm.fetchData,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedRawMaterials.length
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("PurchaseOrders.Selected") } },
                [
                  _c(
                    "el-table",
                    { attrs: { data: _vm.selectedRawMaterials } },
                    [
                      _c("el-table-column", {
                        attrs: { label: _vm.$t("route.Supplier") },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(scope.row.supplier.name) +
                                      "\n          "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4153162720
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: _vm.$t("PurchaseOrders.RawMaterial") },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        scope.row.nameEng
                                          ? scope.row.nameEng
                                          : scope.row.nameChin
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1839815187
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("PurchaseOrders.Action"),
                          width: "100",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "danger" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDeselect(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("PurchaseOrders.Deselect")
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2139663273
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v(_vm._s(_vm.$t("PurchaseOrders.Confirm")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-circle-close" },
              on: { click: _vm.handleCancel },
            },
            [_vm._v(_vm._s(_vm.$t("PurchaseOrders.Cancel")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }